import { FC, useEffect } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import LoanApplication from './LoanApplication'
import LoanType from './LoanType'
import LoanComplete from './LoanComplete'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { useDispatch, useSelector } from 'react-redux'
import { parse } from 'query-string'
import { getIntegrationURLFromENV } from '../../../utils/getIntegrationURLFromENV'
import axios from 'axios'
import { setFundDetails } from './redux/actions'

const LoanApplicationWrapper: FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const searchQuery: any = parse(history.location.search)
  const partnerDetails = useSelector((state: any) => state.loan.partner)
  useEffect(() => {
    if (partnerDetails != null && partnerDetails?.funds?.length > 0) {
      const selectedFund = partnerDetails?.funds[0]
      getFundDetails(selectedFund)
    }
  }, [partnerDetails?.funds?.length])

  const getFundDetails = async (fundId: string) => {
    const env = localStorage.getItem('env')
    const API_URL = getIntegrationURLFromENV(searchQuery?.env || env)
    const fundData = await axios.get(`${API_URL}ext/api/funds/${fundId || ''}`)

    if (fundData.data && fundData.status === 200) {
      dispatch(setFundDetails(fundData.data))
    }
  }

  return (
    <>
      <div className='headerAlexi'>
        <div className='container'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/ccrLogo.png')} />
        </div>
      </div>
      <Switch>
        <Route path='/application/completed' exact>
          {' '}
          <LoanComplete />{' '}
        </Route>
        <Route path='/application/completed/:id' exact>
          {' '}
          <LoanComplete />{' '}
        </Route>
        <Route path='/application/type' exact>
          {' '}
          <LoanType />{' '}
        </Route>
        <Route path='/application/type/:type' exact>
          {' '}
          <LoanType />{' '}
        </Route>
        <Route path='/application' exact>
          {' '}
          <LoanApplication />{' '}
        </Route>
        <Route path='/application/:id' exact>
          {' '}
          <LoanApplication />{' '}
        </Route>
      </Switch>
    </>
  )
}

export default LoanApplicationWrapper
